export class SwiperSlider {
  init()
  {

        $('.swiper-container.gallery-top').each(function(index){
             var autoplay = false;
             var loopedSlidesNbr =  $(this).find('.swiper-slide').length;
             if($(this).data('autoplay') && $(this).data('autoplay') === true){
                 autoplay = {
                     delay: ($(this).data('autoplayDelay') ? $(this).data('autoplayDelay') : 1500),
                     disableOnInteraction: true
                 };
             }

             var galleryTop = new Swiper($(this), {
                 slidesPerView: $(this).data('items'),
                 loopedSlides: loopedSlidesNbr,
                 loop: ($(this).data('loop') ? $(this).data('loop') : false),
                 centeredSlides: ($(this).data('slideCenter') || ($(this).data('loop') === true && $(this).siblings('.swiper-container.gallery-thumbs').length > 0) ? true : false),
                 spaceBetween: 30,
                 pagination: {
                     el: $(this).siblings('.swiper-pagination'),
                     type: 'bullets',
                     clickable: true
                 },
                 autoplay: autoplay,
                 speed: 1500,
                 navigation: {
                     nextEl: $(this).siblings('.swiper-controls').find('.swiper-button-next'),
                     prevEl: $(this).siblings('.swiper-controls').find('.swiper-button-prev'),
                 },
                 breakpoints: {
                     1200: {
                       slidesPerView: ($(this).data('itemsXl') ? $(this).data('itemsXl') : $(this).data('items')),
                       spaceBetween: 40,
                     },
                     992: {
                       slidesPerView: ($(this).data('itemsLg') ? $(this).data('itemsLg') : $(this).data('items')),
                       spaceBetween: 30,
                     },
                     768: {
                       slidesPerView: ($(this).data('itemsMd') ? $(this).data('itemsMd') : $(this).data('items')),
                       spaceBetween: 20,
                     },
                     576: {
                       slidesPerView: ($(this).data('itemsSm') ? $(this).data('itemsSm') : $(this).data('items')),
                       spaceBetween: 10,
                     }
                   }
             });

             var galleryThumbs = new Swiper($(this).siblings('.swiper-container.gallery-thumbs'), {
                 spaceBetween: 10,
                 centeredSlides: true,
                 slidesPerView: 'auto',
                 touchRatio: 0.2,
                 slideToClickedSlide: true,
                 loopedSlides: loopedSlidesNbr,
                 loop: ($(this).data('loop') ? $(this).data('loop') : false),
               });

             if(galleryThumbs.controller && galleryThumbs.controller !== "undefined"){
                 galleryTop.controller.control = galleryThumbs;
                 galleryThumbs.controller.control = galleryTop;
             }
        })
    }
}